export default "__VITE_ASSET__CjmYublg__"